export const aplicarFiltrosGenerico = (items, filtros, mapa = {}) => {
  const activos = Object.entries(filtros).filter(([, v]) => {
    if (v === null || v === '') {
      return false
    }

    if (Array.isArray(v) && !v.length) {
      return false
    }

    return true
  })

  if (!activos.length) {
    return items
  }

  return items.filter((item) =>
    activos.every(([campo, valor]) => {
      const config = mapa[campo]

      if (!config) {
        return Object.keys(mapa).length === 0 ? item[campo] === valor : true
      }
      if (!config.filterFn) {
        return true
      }

      return config.filterFn(item, valor, filtros)
    })
  )
}
